import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import type { FieldMapping } from '../../services/api';

export interface DeleteMappingDialogProps {
  open: boolean;
  mapping: FieldMapping | null;
  deleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteMappingDialog: React.FC<DeleteMappingDialogProps> = ({
  open,
  mapping,
  deleting,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>Delete Mapping</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to delete the mapping for{' '}
        <strong>
          {mapping?.target_table}.{mapping?.target_field}
        </strong>
        ? This action cannot be undone.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button color="error" variant="contained" onClick={onConfirm} disabled={deleting}>
        {deleting ? 'Deleting...' : 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteMappingDialog;
